import { render, staticRenderFns } from "./CustomerCBSR.vue?vue&type=template&id=68768a50&scoped=true&"
import script from "./CustomerCBSR.vue?vue&type=script&lang=ts&"
export * from "./CustomerCBSR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68768a50",
  null
  
)

export default component.exports